export function auditTransform(value) {
    const types = {
        '0': '未认证',
        '1': '认证中',
        '2': '认证成功',
        '3': '认证失败',
    };
    return types[value] || '';
}

export function invoiceTransform(value) {
    const types = {
        '1': "待审核",
        '2': "审核通过",
        '3': "审核失败",
    };
    return types[value] || '';
}

export function personAuthResult(value) {
    const types = {
        '0': "未认证",
        '1': "认证中",
        '2': "认证成功",
        '3': "认证失败",
    };
    return types[value] || '';
}

export function xueliStatusForm(value) {
    const types = {
        '10': "学历不限",
        '20': "初中",
        '30': "高中",
        '40': "专科",
        '50': "本科",
        '60': "硕士",
        '70': "博士",
    };
    return types[value] || '';
}

export function sexAuthResult(value) {
    const types = {
        'male': "男",
        'female': "女",
        'unlimited': "不限"
    };
    return types[value] || '';
}

export function staskStatusResult(value) {
    const types = {
        '0': "已下架",
        '1': "展示中",
        '2': "已过期"
    };
    return types[value] || '';
}

export function xiaStatusResult(value) {
    const types = {
        '0': "已下架",
        '1': "展示中",
        '2': "已过期"
    };
    return types[value] || '';
}

export function taskStatustForm(value) {
    const types = {
        '0': "未发布",
        '1': "已发布",
        '2': "已过期"
    };
    return types[value] || '';
}

export function signStatusForm(value) {
    const types = {
        '0': "待签约",
        '1': "签约中",
        '2': "已签约",
        '3': "未签约",
        '4': "已过期",
    };
    return types[value] || '';
}

export function applyStatusForm(value) {
    const types = {
        '0': "申请中",
        '1': "邀请面试中",
        '2': "面试中",
        '3': "拒绝申请",
        '4': "拒绝面试",
        '5': "面试失败",
        '6': "已录取",
    };
    return types[value] || '';
}

export function confirmStatusForm(value) {
    const types = {
        '1': "未确认",
        '2': "已确认",
        '3': "拒绝确认"
    };
    return types[value] || '';
}

export function colorTransform(value) {
    const types = {
        '00': '#3083FF',
        '10': '#52C41A',
        '20': '#F5222D',
    };
    return types[value] || '';
}

export function timeTransform(value) {
    var temp = new Date(value);
    var t = temp.getFullYear()+"-"+(temp.getMonth()+1)+"-"+temp.getDate();
    return t;
}

export function payTransform(value) {
    const types = {
        '1': '余额支付',
        '2': '线下支付',
    };
    return types[value] || '';
}

export function tradeTransform(value) {
    const types = {
        '1': '线下充值',
        '2': '购买产品',
    };
    return types[value] || '';
}
export function StatusForm(value) {
    const types = {
        '00': "处理完成",
        '01': "待处理",
        '02': "处理中"
    };
    return types[value] || '';
}
export function workloadMakeForm(value) {
    const types = {
        '1': "手动上传",
        '2': "批量上传",
        '3': "API接口"
    };
    return types[value] || '';
}

export function settleWayForm(value) {
    const types = {
        '1': "按需求单结算",
        '2': "按发薪表格结算",
        '3': "API方式结算"
    };
    return types[value] || '';
}

export function chanpinsform(value) {
    const types = {
        '1': '单个产品',
        '2': '组合产品',
    };
    return types[value] || '';
}

export function spunFenform(number) {
    return isNaN(number) ? 0 : parseFloat((number * 100).toFixed(0));
}




// WEBPACK FOOTER //
// ./src/filters/textTransform.js